module.exports = __webpack_public_path__ + "static/media/sidebar-sms-selected.f9a78837.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-sms-selected.svg
// module id = 790
// module chunks = 0